import { useState, useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";

import categoryService from "app/common/services/categoryService";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";

import { extractPrimaryCategoryFromParams } from "../routes/routeUtils";

//Route names where a2d btn must be available
const exclusions = ["market_research_overview", "market_research_overview_v2"];

// Hook to omit rendering of add to Dashboard button if segments are included in custom industry
export const useNoRenderA2D = () => {
    const { params, state } = useCurrentStateAndParams();
    const [isA2DAvailable, setIsA2DAvailable] = useState(true);

    const { category } = params;
    const primaryCategory = extractPrimaryCategoryFromParams(category);
    const categoryObject = categoryService.categoryQueryParamToCategoryObject(primaryCategory);

    useEffect(() => {
        if (CategoryServiceUtils.hasSegments(categoryObject) && !exclusions.includes(state.name)) {
            setIsA2DAvailable(false);
        }
    }, []);

    return { isA2DAvailable };
};
